import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "timi-dashboard-container" }
const _hoisted_2 = { class: "date-slider" }
const _hoisted_3 = { class: "date-slider-current" }
const _hoisted_4 = {
  key: 0,
  class: "info"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = {
  key: 0,
  class: "statistic-wrapper"
}
const _hoisted_8 = { class: "statistic-item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "statistic-item" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "statistic-item" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "actions" }
const _hoisted_15 = { class: "statistic-item" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "actions" }
const _hoisted_18 = {
  key: 0,
  class: "statistic-item"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "list-workbreaks" }
const _hoisted_23 = { class: "workbreak-from" }
const _hoisted_24 = { class: "workbreak-to" }
const _hoisted_25 = { class: "workbreak-to" }
const _hoisted_26 = { class: "actions" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_MultiplePresenceForm = _resolveComponent("MultiplePresenceForm")!
  const _component_Card = _resolveComponent("Card")!
  const _component_MultipleWorkbreakForm = _resolveComponent("MultipleWorkbreakForm")!
  const _component_TimeEntryForm = _resolveComponent("TimeEntryForm")!
  const _component_TimeEntryCard = _resolveComponent("TimeEntryCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconButton, {
      icon: _ctx.store.getters.svgIcons.arrowbackward,
      class: "go-back-btn",
      label: _ctx.$t('button.back'),
      dense: true,
      onOnClick: _ctx.handleGoBack
    }, null, 8, ["icon", "label", "onOnClick"]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.employee.number) + ": " + _toDisplayString(_ctx.employee.firstName) + " " + _toDisplayString(_ctx.employee.lastName), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconButton, {
        icon: _ctx.store.getters.svgIcons.arrowbackward,
        class: "",
        onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSwitchDay(-1)))
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.dateInputEnabled)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.displayActiveDay), 1))
          : _createCommentVNode("", true),
        (!_ctx.dateInputEnabled)
          ? (_openBlock(), _createBlock(_component_IconButton, {
              key: 1,
              icon: _ctx.store.getters.svgIcons.currentDay,
              onOnClick: _ctx.onSwitchCalendarButton
            }, null, 8, ["icon", "onOnClick"]))
          : _createCommentVNode("", true),
        (_ctx.dateInputEnabled)
          ? (_openBlock(), _createBlock(_component_DateInput, {
              key: 2,
              value: _ctx.formatDateInputValue(_ctx.activeDay),
              onOnChange: _ctx.onDateInputDateChange
            }, null, 8, ["value", "onOnChange"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_IconButton, {
        icon: _ctx.store.getters.svgIcons.arrowforward,
        onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSwitchDay(1)))
      }, null, 8, ["icon"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.presenceFormVisible)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              title: _ctx.$t('headline.editPresence'),
              class: "transparent border"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultiplePresenceForm, {
                  presences: _ctx.editPresences,
                  onUpdate: _ctx.onPresenceEditFormUpdate,
                  onDelete: _ctx.onPresenceEditFormDelete,
                  onClose: _ctx.onPresenceEditFormClose,
                  onError: _ctx.onPresenceEditFormError
                }, null, 8, ["presences", "onUpdate", "onDelete", "onClose", "onError"])
              ]),
              _: 1
            }, 8, ["title"]))
          : (_openBlock(), _createBlock(_component_Card, {
              key: 1,
              title: _ctx.$t('day.dailyStatistic')
            }, {
              default: _withCtx(() => [
                (_ctx.dataLoaded.presence)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('day.presenceTime')), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.convertSecondsToTime(_ctx.presenceTime)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('day.workingtimeSUM')), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.convertSecondsToTime(_ctx.timeSum)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('day.comeAt')), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.activePresence.come ? _ctx.convertTimeStampToDate(_ctx.activePresence.come) + ', ' + _ctx.convertToTime(_ctx.activePresence.come) + " " + _ctx.$t('label.oClock') : "--"), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_IconButton, {
                            icon: _ctx.store.getters.svgIcons.pencil,
                            onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPresenceForm(_ctx.activePresence)))
                          }, null, 8, ["icon"]),
                          false
                            ? (_openBlock(), _createBlock(_component_IconButton, {
                                key: 0,
                                icon: _ctx.store.getters.svgIcons.delete,
                                onOnClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onRemovePresence(_ctx.activePresence, 'come')))
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('day.goAt')), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.activePresence.go ? _ctx.convertTimeStampToDate(_ctx.activePresence.go) + ', ' + _ctx.convertToTime(_ctx.activePresence.go) + " " + _ctx.$t('label.oClock') : "--"), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_IconButton, {
                            icon: _ctx.store.getters.svgIcons.pencil,
                            onOnClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPresenceForm(_ctx.activePresence)))
                          }, null, 8, ["icon"]),
                          false
                            ? (_openBlock(), _createBlock(_component_IconButton, {
                                key: 0,
                                icon: _ctx.store.getters.svgIcons.delete,
                                onOnClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onRemovePresence(_ctx.activePresence, 'go')))
                              }, null, 8, ["icon"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('day.lastInteractivity')) + ":", 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.latestInteraction + " " + _ctx.$t('label.oClock')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "svgicon svgicon--loader",
                      innerHTML: _ctx.store.getters.svgIcons.loader
                    }, null, 8, _hoisted_19))
              ]),
              _: 1
            }, 8, ["title"]))
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_ctx.dataLoaded.workbreaks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_ctx.workbreakFormVisible)
                ? (_openBlock(), _createBlock(_component_Card, {
                    key: 0,
                    title: _ctx.$t('headline.editWorkbreak'),
                    class: "transparent border"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MultipleWorkbreakForm, {
                        workbreaks: _ctx.editWorkbreaks,
                        onUpdate: _ctx.onWorkbreakEditFormUpdate,
                        onDelete: _ctx.onWorkbreakEditFormDelete,
                        onClose: _ctx.onWorkbreakEditFormClose
                      }, null, 8, ["workbreaks", "onUpdate", "onDelete", "onClose"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : (_openBlock(), _createBlock(_component_Card, {
                    key: 1,
                    title: _ctx.$t('day.workbreaks')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workbreaks, (workbreak) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: workbreak.uid,
                            class: "list-entry-workbreak"
                          }, [
                            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('label.workbreakStart')) + " " + _toDisplayString(_ctx.convertTimeStampToTime(workbreak.start)), 1),
                            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('label.workbreakStop')) + " " + _toDisplayString((workbreak.stop ? _ctx.convertTimeStampToTime(workbreak.stop) : '-')), 1),
                            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('label.workbreakPaused')) + " " + _toDisplayString((workbreak.getTimePaused() ? _ctx.convertSeconds(workbreak.getTimePaused()) : '-')), 1),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_IconButton, {
                                icon: _ctx.store.getters.svgIcons.pencil,
                                onOnClick: ($event: any) => (_ctx.onWorkbreakForm(workbreak))
                              }, null, 8, ["icon", "onOnClick"]),
                              false
                                ? (_openBlock(), _createBlock(_component_IconButton, {
                                    key: 0,
                                    icon: _ctx.store.getters.svgIcons.delete,
                                    onOnClick: ($event: any) => (_ctx.onRemoveWorkbreak(workbreak))
                                  }, null, 8, ["icon", "onOnClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128)),
                        (!_ctx.workbreaks.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.$t('label.workbreakNone')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        (_ctx.dataLoaded.timeentries)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              (_ctx.timeEntryFormVisible)
                ? (_openBlock(), _createBlock(_component_Card, {
                    key: 0,
                    title: _ctx.$t('headline.editTimeentry'),
                    class: "transparent border"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TimeEntryForm, {
                        entry: _ctx.editEntry,
                        onCancel: _ctx.onTimeentryEditFormCancel,
                        onUpdate: _ctx.onTimeentryEditFormUpdate
                      }, null, 8, ["entry", "onCancel", "onUpdate"])
                    ]),
                    _: 1
                  }, 8, ["title"]))
                : (_openBlock(), _createBlock(_component_Card, {
                    key: 1,
                    title: _ctx.$t('dashboard.activities')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeEntries, (entry) => {
                        return (_openBlock(), _createBlock(_component_TimeEntryCard, {
                          key: entry.uid,
                          entry: entry,
                          mode: _ctx.userMode,
                          onDelete: _ctx.onDeleteTimeEntry,
                          onEdit: _ctx.onEditTimeEntry
                        }, null, 8, ["entry", "mode", "onDelete", "onEdit"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["title"]))
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "svgicon svgicon--loader",
              innerHTML: _ctx.store.getters.svgIcons.loader
            }, null, 8, _hoisted_31))
      ])
    ])
  ]))
}